import(/* webpackMode: "eager", webpackExports: ["DetailList"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/list/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/menu/sub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/pagination/paginator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadCrumb","SubTitle"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/title/index.tsx");
